<template>
    <div class="box" :style="{ backgroundImage: 'url(' + bg + ')' }">
        <div class="wrap">
            <div class="title reveal-bottom">{{ title }}</div>
            <div class="subTitle reveal-bottom">{{ subTitle }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "DetailHeader",
    data() {
        return {
            bg: require("@/assets/images/sub_page_banner_7.jpg"),
        };
    },
    props: {
        title: String,
        subTitle: String,
    },
};
</script>
<style scoped>
.box {
    height: 600px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.wrap {
    width: 1200px;
    margin: auto;
}
.title {
    font-size: 44px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 60px;
    font-weight: bold;
    width: 730px;
}
.subTitle {
    margin-top: 36px;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 29px;
    width: 680px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/CustomerDetail/DetaiHeader.vue